export const indentsNaming = ['xxxxxs', 'xxxxs', 'xxxs', 'xxs', 'xs', 's', 'xm', 'm', 'l', 'xl', 'xxl', 'xxxl', 'xxxxl', 'xxxxxl', 'xxxxxxl'] as const;

export type IndentsType = typeof indentsNaming[number];

const themeIndents: Record<IndentsType, number> = {
    'xxxxxs': 0,
    'xxxxs': 2,
    'xxxs': 4,
    'xxs': 8,
    'xs': 12,
    's': 16,
    'xm': 20,
    'm': 24,
    'l': 32,
    'xl': 40,
    'xxl': 52,
    'xxxl': 64,
    'xxxxl': 80,
    'xxxxxl': 96,
    'xxxxxxl': 128,
} as const;

export default themeIndents;
